import React from "react";
import { object, bool, string } from "prop-types";
import get from "lodash/get";

import MagazineEditions from "../../../arrow/components/Rows/MagazineEditions";
import { useLatestMagazines } from "../../customHooks/useLatestMagazines";
import { useDeviceType } from "../../customHooks/useDeviceType";

import "./latest-magazine-issues.m.css";

export const LatestMagazineIssues = ({
  collection,
  isStoryPage = false,
  skipMagazineId,
  pageType,
  story,
  config,
  title,
}) => {
  const allMagazineIssues = useLatestMagazines(skipMagazineId);
  const magazineIssues = skipMagazineId
    ? allMagazineIssues?.filter((issue) => issue.id !== skipMagazineId)
    : allMagazineIssues;

  const deviceType = useDeviceType();
  const isDesktop = deviceType === "desktop";

  const {
    enableEditionsTitle = true,
    rowTitle = title || "Latest Magazine Issues",
    showRowTitle = true,
  } = get(collection, ["associated-metadata"], {});

  const contextConfig = {
    enableEditionsTitle,
    rowTitle,
    showRowTitle,
    showBottomReadMore: !isDesktop,
    showTitleReadMore: isDesktop,
  };

  return (
    <div className="latest-magazine-issues" styleName={`latest-magazine-issues ${isStoryPage ? "story-page" : ""}`}>
      <MagazineEditions
        collection={magazineIssues}
        config={contextConfig}
        limit={isStoryPage ? 12 : 5}
        isStoryPage={isStoryPage}
        pageType={pageType}
        story={story}
        qtConfig={config}
      />
    </div>
  );
};

LatestMagazineIssues.propTypes = {
  collection: object,
  isStoryPage: bool,
  skipMagazineId: string,
  pageType: string,
};

LatestMagazineIssues.defaultProps = {
  isStoryPage: false,
  pageType: "",
};
